import { Box, Button, Grid2 } from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import Switch from '@mui/material/Switch';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#ECE0FF',
    color: '#747474',
    // maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    // border: '1px solid #dadde9',
    borderRadius: '15px',
    boxShadow: '0px 0px 11px 0px rgba(128, 139, 157, 0.15)',
  },
}));

const drawerWidth = 300;

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
const label = { inputProps: { 'aria-label': 'Switch demo' } };

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ComponentsUi = () => {



  const [tab, setTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };


  const [pop, setPop] = useState(false);
  const handlePopOpen = () => setPop(true);
  const handlePopClose = () => setPop(false);

  const [age, setAge] = React.useState("");
  const [anchorOrigin, setAnchorOrigin] = useState({
    vertical: 'top',
    horizontal: 'right',
  });

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  // snackbar
  const [state, setState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;

  const handleClick = (newState) => () => {
    setState({ ...newState, open: true });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };
  // snackbar

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <div className="dashboard">
      <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
        <SideBar />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: isLgUp ? 5 : 1,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            marginTop: isLgUp ? "50px" : "80px",
          }}
        >
          <Grid2 container spacing={2}>
            <Grid2
              item
              size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
              className="mb-20"
            >
              <div className="component-box">
                <h2>h1, h2, p tag</h2>
                <h1>Create Your First AI Voice Assistant</h1>
                <p>
                  Rorem ipsum dolor sit amet, consectetur adipiscing elit.Rorem
                  ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
                <h2>Assistant Name</h2>
              </div>
            </Grid2>
            <Grid2
              item
              size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
              className="mb-20"
            >
              <div className="component-box">
                <h2>Button</h2>

                <div className="graient-btn">
                  <Button>Create an AI Voice Assistant</Button>
                </div>
                <Stack direction="row" spacing={5}>
                  <div className="border-graient mt-10">
                    <Button>Back</Button>
                  </div>
                  <div className="shadow-btn mt-10">
                    <Button>Fetch Data</Button>
                  </div>
                  <div className="bg-clr mt-10">
                    <Button>Test Your Assistant</Button>
                  </div>
                  <div className="theme-borde-clr mt-10">
                    <Button>SET UP</Button>
                  </div>
                </Stack>
              </div>
            </Grid2>
            <Grid2
              item
              size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
              className="mb-20"
            >
              <div className="component-box">
                <h2>Input</h2>
                <div className="input-common mt-20">
                  <label>Enter Website URL :</label>
                  <TextField fullWidth id="fullWidth" />
                </div>
                <div className="input-common mt-20">
                  <label>language</label>
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={age}
                      onChange={handleChange}
                    >
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            </Grid2>
            <Grid2
              item
              size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
              className="mb-20"
            >
              <div className="component-box">
                <h2>Toaster</h2>
                <div className="toaster-btn">
                  <Button
                    onClick={handleClick({
                      vertical: "top",
                      horizontal: "right",
                    })}
                  >
                    {" "}
                    Success toaster{" "}
                  </Button>


                </div>

                <Snackbar
                  className="snack-success"
                  anchorOrigin={anchorOrigin}
                  open={open}
                  onClose={handleClose}
                  key={anchorOrigin.vertical + anchorOrigin.horizontal}
                  TransitionComponent={SlideTransition} // Add Slide transition
                  message={
                    <span style={{ display: "flex", alignItems: "center", color: '#fff' }}>
                      <CheckCircleIcon
                        style={{ marginRight: 8, color: "#fff" }}
                      />
                      This is a success Alert!

                    </span>
                  }
                />

                <h2>Switch</h2>
                <Switch />
              </div>
            </Grid2>
            <Grid2
              item
              size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
              className="mb-20"
            >
              <div className="component-box">
                <h2>Modal</h2>

                <div className="modal-popup bg-clr">
                  <Button onClick={handlePopOpen}>Open modal</Button>
                  <Modal
                    open={pop}
                    onClose={handlePopClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box className="common-modal-box">
                      <Typography id="modal-modal-title" variant="h6" component="h2">
                        Delete
                      </Typography>
                      <Stack direction="row" spacing={2}>
                        <div className="bg-clr">
                          <Button>Delete</Button>
                        </div>
                        <div className="bg-clr">
                          <Button>Cancel</Button>
                        </div>
                      </Stack>
                    </Box>
                  </Modal>
                </div>
              </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <div className="component-box">
                <h2 style={{ color: "#94a3b8" }}>Tabs</h2>
                <div className="tab-common">
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                      value={tab}
                      onChange={handleTabChange}
                      aria-label="basic tabs example"
                    >
                      <Tab label="Item One" {...a11yProps(0)} />
                      <Tab label="Item Two" {...a11yProps(1)} />
                      <Tab label="Item Three" {...a11yProps(2)} />
                    </Tabs>
                  </Box>
                  <CustomTabPanel value={tab} index={0}>
                    Item One
                  </CustomTabPanel>
                  <CustomTabPanel value={tab} index={1}>
                    Item Two
                  </CustomTabPanel>
                  <CustomTabPanel value={tab} index={2}>
                    Item Three
                  </CustomTabPanel>
                </div>
              </div>
            </Grid2>

            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <div className="display-1">
            <h1>anbu</h1>
            <HtmlTooltip placement="right"
        title={
          <React.Fragment>
            <Typography color="inherit" sx={{fontSize:'12px',padding:'7px'}}>This will be the main objective that your AI assistant will try to achieve once its in converstation with your contacts</Typography>

          </React.Fragment>
        }
      >
        

        <InfoRoundedIcon/>
        
      </HtmlTooltip></div>
            </Grid2>
          </Grid2>
        </Box>
      </Box>
    </div>
  );
};

export default ComponentsUi;
